<template>
  <v-layout class="justify-end mt-3">
    <v-btn
      class="mr-1"
      :disabled="page===1"
      x-small 
      outlined
      @click="nextpage (page-1)"
    >
      {{ $t('before') }}
    </v-btn>   
    <v-btn 
      v-if="page>=3"
      x-small
      outlined
      class="mr-1"
      @click="nextpage (1)" 
    >
      {{ 1 }}
    </v-btn>  
    <div v-if="page>=3">
      ...
    </div>
    <v-btn  
      v-if="page!=1" 
      x-small
      class="mr-1"
      outlined
      @click="nextpage (page-1)" 
    >
      {{ page-1 }}
    </v-btn>  
    <v-btn  
      x-small 
      color="var(--bg-secondary-color)"  
      class="mr-1"
      dark
      depressed
      @click="nextpage (page)"
    >
      {{ page }}
    </v-btn>  
    <v-btn  
      v-if="page<=meta.total_page-1" 
      x-small
      class="mr-1"
      outlined
      @click="nextpage (page+1)" 
    >
      {{ page+1 }}
    </v-btn>  
    <div v-if="page<=meta.total_page-3">
      ...
    </div>
    <v-btn
      v-if="page<meta.total_page-1"
      x-small
      class="mr-1"
      outlined
      @click="nextpage (meta.total_page)"  
    >
      {{ meta.total_page }}
    </v-btn> 
    <v-btn
      x-small
      class="mr-1"
      outlined
      :disabled="page>=meta.total_page"
      @click="nextpage (page+1)" 
    >
      {{ $t('next') }}
    </v-btn>
  </v-layout>
</template>
<script>
export default {
  props : {
    page : {
      type :Number,
      default:()=>0
    },
    meta : {
      type : Object,
      default : ()=>{}
    }
  },
  methods : {
    nextpage (value){
      this.$emit('nextpage',value)
    }
  }
}
</script>